import {
  Injectable,
  ComponentFactoryResolver,
  ViewContainerRef,
} from '@angular/core';
import { InterpolateService } from '@ispm/shared/services/interpolate.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { isEmpty, has } from 'lodash';
import { DynamicFormItem } from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import { ITEMS_TYPES } from '@ispm/dynamic-form/constants/ItemsTypes';
import { DynamicFormComponent } from '@ispm/dynamic-form/dynamic-form.component';
import { VALUE_TYPES } from '@ispm/dynamic-form/constants/value-type.enum';

@Injectable()
export class TooltipService {
  private _componentRef: any;
  private tooltipHtml: string;
  private formConfig: any;
  public htmlProvider$: BehaviorSubject<any> = new BehaviorSubject('');

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
              private _interpolateService: InterpolateService) {
  }

  getTooltipContent(data, tooltipConfiguration: any, entryRef: ViewContainerRef): Observable<any> {
    let payloadData;
    if (has(tooltipConfiguration, 'pathToData')) {
      payloadData = data;
    }
    else if (data) {
      if (Object.keys(data[0]).length > 1) {
        payloadData = { };
        payloadData = Object.assign({ }, ...data);
      } else {
        payloadData = [];
        Object.keys(data[0]).forEach(key => {
          payloadData = payloadData.concat(data[0][key]);
        });
      }
    }

    if (tooltipConfiguration.hasOwnProperty('pattern')) {
      this.tooltipHtml = this._interpolateService.interpolate(tooltipConfiguration.pattern, payloadData);
      return Observable.of(this.tooltipHtml);
    } else if ((tooltipConfiguration.hasOwnProperty('component')) && (isEmpty(this.formConfig))) {

      if (this._componentRef) {
        this._componentRef.instance.destroy(); // destroy the previous component if exists
      }

      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(DynamicFormComponent);
      this._componentRef = entryRef.createComponent(componentFactory);

      const widgetItem = DynamicFormItem.builder('', tooltipConfiguration.pathToData
        || '#TOOLTIP', ITEMS_TYPES.WIDGET)
        .setComponentToLoad(tooltipConfiguration.component)
        .setWidgetPayload(tooltipConfiguration.payload)
        .setValueType(VALUE_TYPES.AUTO);
      this.formConfig = [widgetItem];
      this._componentRef.instance.formData = payloadData;
      this._componentRef.instance.formConfig = this.formConfig;

      this._componentRef.hostView.markForCheck();
      this._componentRef.hostView.detectChanges();
      setTimeout(() => {
        const currentDOM = this._componentRef.location.nativeElement.innerHTML;
        this.htmlProvider$.next(currentDOM);
      }, 0);

      return this.htmlProvider$;
    } else {
        if (this._componentRef) {
          this._componentRef.instance.formData = payloadData;
          if (!this._componentRef.hostView['destroyed']) {
            this._componentRef.hostView.markForCheck();
            this._componentRef.hostView.detectChanges();
            setTimeout(() => {
              const currentDOM = this._componentRef.location.nativeElement.innerHTML;
              this.htmlProvider$.next(currentDOM);
            }, 0);
          }
        }
       return this.htmlProvider$;
    }

  }

  destroy() {
   // this._componentRef.instance.destroy(); Causing error as undefined and removing a normal table
  }
}
